import React from 'react';

function Privacy() {
  return (
    <div className="py-20 px-6 max-w-4xl mx-auto text-slate-800">
      <h1 className="text-4xl font-black mb-8">Privacy Policy</h1>
      <p className="mb-4 text-slate-500 italic">Last Updated: March 2026</p>
      
      <section className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold mb-2">1. Information Collection</h2>
          <p>We collect information you provide directly to us via our contact form, including your name, email address, and phone number.</p>
        </div>

        {/* --- UPDATED: "alerts" removed to align with Marketing use case --- */}
        <div className="bg-blue-50 p-6 rounded-2xl border-l-4 border-blue-600">
          <h2 className="text-2xl font-bold mb-2 text-blue-900">2. SMS Terms & Consent</h2>
          <p className="text-blue-800">
            By providing your phone number and checking the consent box, you agree to receive marketing messages from Zygma Growth Solutions. 
            <strong> Mobile information will not be shared with third parties or affiliates for marketing or promotional purposes.</strong> All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold mb-2">3. Opt-Out & Support</h2>
          <p>You can cancel the SMS service at any time. Just text "STOP" to our number. After you send the SMS message "STOP" to us, we will send you an SMS message to confirm that you have been unsubscribed. For help, reply "HELP".</p>
        </div>

        <div>
          <h2 className="text-2xl font-bold mb-2">4. Data Security</h2>
          <p>We implement a variety of security measures to maintain the safety of your personal information when you enter, submit, or access your personal information.</p>
        </div>
      </section>
    </div>
  );
}

export default Privacy;